import { ApolloError } from '@apollo/client'

import { ErrorTranslator } from 'src/translators'
import { ErrorEntity } from 'src/types'

export const useError = () => {
  const toErrorEntities = (error: unknown): ErrorEntity[] => {
    const apolloError = error as ApolloError
    return ErrorTranslator.toEntities(apolloError)
  }

  return {
    toErrorEntities,
  }
}
